import * as React from 'react'
import { ErrorMessage } from '../../../shared-components/ErrorMessage'
import { RadioButton } from '../../../shared-components/RadioButton'
import { useScreenTracking } from '../../../shared-hooks/useScreenTracking'
import { track } from '../../../utils/analytics'
import { SignupCard } from '../SignupCard'
import { SSOStep, SSOStepProps } from './SSOFlow'

const PASSWORD_AUTH = 'Uber password'
const EMAIL_AUTH = 'Email a 4 digit pin'
const AUTH_OPTIONS = [PASSWORD_AUTH, EMAIL_AUTH]

type AuthSelectionProps = SSOStepProps & {
  setSSOStep: React.Dispatch<React.SetStateAction<SSOStep>>
  sessionId: string
}

export const AuthSelection = ({
  setSSOStep,
  sessionId,
  makeSSORequest,
}: AuthSelectionProps): JSX.Element => {
  useScreenTracking('UberAuthSelectionView', 'View uber auth selection screen')

  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    setIsSubmitting(true)
    setErrorMessage('')

    track('UberSelectAuthMethod', 'Uber select auth method')

    const selectedOption = event.currentTarget.value
    if (selectedOption === PASSWORD_AUTH) {
      setErrorMessage('')
      setIsSubmitting(false)
      setSSOStep(SSOStep.UberPassword)
    } else if (selectedOption === EMAIL_AUTH) {
      const body = {
        session_id: sessionId,
        stage: 'options',
        event_type: 'TypeEmailOTP',
      }

      try {
        await makeSSORequest(
          body,
          'Something unexpected happened, please try again later.'
        )
      } catch (error) {
        setIsSubmitting(false)
        setErrorMessage(error?.message)
      }
    } else {
      setIsSubmitting(false)
      setErrorMessage('Please select a method.')
    }
  }

  return (
    <SignupCard
      heading='Select one-time verification method'
      subheading='One last step to securely connect to your Uber account.'
    >
      <div className='flex flex-col gap-4'>
        {AUTH_OPTIONS.map((authOption) => (
          <RadioButton
            key={authOption}
            value={authOption}
            type='button'
            onClick={handleClick}
            disabled={isSubmitting}
          >
            {authOption}
          </RadioButton>
        ))}
        <ErrorMessage>{errorMessage}</ErrorMessage>
      </div>
    </SignupCard>
  )
}
